/**
 * 结构专业的二级控制器的控制器类型编号
 */
export enum STRUCTURE_CTRL_TYPE {
    ADD_SBEAM = 7000, // 添加结构梁
    ADD_SCOLUMN = 7001, // 添加结构柱
    ADD_SBAR = 7002, // 添加结构杆
    ADD_SBRACE = 7003, // 添加结构支撑
    ADD_SWALL = 7004, // 添加结构墙
    ADD_SFLOOR = 7005, // 添加结构板
    ADD_SGRIDPOINT = 7006, // 添加结构节点
}